import axios from "axios";
import { Navigate } from "react-router-dom";
import baseUrl from "../Api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

export async function grpschoolview(id) {
  try {
    return await axios
    .get(`${baseUrl}/cms/view-school-statement?school_id=${id}&school_or_funder=3`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function grpschdetail(id) {
  try {
    return await axios
      .get(`${baseUrl}/cms/view-mgroup-schools?group_school_id=${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


export async function grpschoollist(id) {
  try {
    return await axios
      .get(`${baseUrl}/cms/group-of-school-list?group_of_school_id=${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function grptourlist(id) {
  try {
    return await axios
      .get(`${baseUrl}/cms/tournament-event-list-group-of-schools?group_of_school_id=${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function grpgallerylist(id) {
  try {
    return await axios
      .get(`${baseUrl}/cms/gallery-list-group-of-schools?group_of_school_id=${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


export async function grpresourceslist(id,srh) {
  try {
    return await axios
      .get(`${baseUrl}/cms/list-resources-group-of-schools?group_of_school_id=${id}&tags_search=${srh}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}



 //Play Session
 export async function grpplaysessionview(id) {
  try {
    return await axios
      .get(`${baseUrl}/cms/view-play-sessions?school_id=${id}&school_or_funder=3`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Medal 
export async function grpmedalslist(data) {
  try {
    return await axios
      .post(`${baseUrl}/cms/group-of-schools-schools-achievements-summary`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
function catcherror(error) {
  console.log(error);
  if (error.response.status === 401) {
    localStorage.clear();
    <Navigate to={"/login"} />;
  } else if (error.response.status === 422) {
    Swal.fire({
      title:
        "There are few errors occured while inserting/updating the data to the database.",
      showCancelButton: false,
      confirmButtonColor: "#d71635",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
      // }).then((result) => {
      //   if (result.isConfirmed) {
      //       window.location.reload();
      //   }
    });
  } else if (error.response.status === 0) {
    toast.error(error.message);
  } else if (error.response.status === 500) {
    toast.error(error.response.statusText);
  } else if (
    error.response.status !== 200 &&
    error.response.data.status === false &&
    error.response.data.code !== 200
  ) {
    toast.error(error.response.data.message);
  } else if (error.request) {
    toast.error(error.request.statusText);
  } else {
    toast.error(error.message);
  }
}
